require('./bootstrap');
require('./bwpublisher');

$(window).on('resize', function () {
	pinFooter();
});

$(function () {
	// Pinned Footer
	pinFooter();

	// Search
	$('.toggle-search').on('click', function () {
		$(this).add('#search').toggleClass('active');
	});

	let query = window.location.search,
		params = new URLSearchParams(query);

	$('#search-term').on('keyup', function () {
		let $term = $(this).val(),
			$url = '/products/results?search=' + $term,
			filters = [{
				filter: 'sort',
				value: $('#search-sort-order').val() ?? 'prod_az'
			}, {
				filter: 'per_page',
				value: $('#search-per-page').val() ?? '16'
			}, {
				filter: 'category',
				value: $('#search-category').val() ?? ''
			}, {
				filter: 'brand',
				value: $('#search-brand').val() ?? ''
			}];

		filters.forEach(filter => {
			if (filter.value.length) {
				$url += '&' + filter.filter + '=' + filter.value;
			}
		});

		$.get($url).then(resp => {
			if ($term == $(this).val()) {
				$('#products_results').html(resp.view);
			}
		});
	});

	$('[data-category]').on('click', function () {
		let $isActive = $(this).hasClass('active'),
			$category = '',
			$url = '/products';

		$('.categories-filter dt.no-children, .categories-filter button').removeClass('active');

		if (! $isActive) {
			$(this).addClass('active');
			$category = $(this).data('category');
		}

		$('#search-category').val($category);
		$('#search-brand').val('');

		if (window.location.pathname.indexOf('brand') > -1) {
			$('#search-form').attr('action', $url).trigger('submit');
		} else {
			$('#search-term').trigger('keyup');
		}
	});

	if (params.has('category')) {
		$('[data-category="' + params.get('category') + '"]').addClass('active').closest('.expandable-content').prev('.expandable-title').trigger('click');
	}

	$('[data-brand]').on('click', function () {
		let $isActive = $(this).hasClass('active'),
			$brand = '',
			$url = '/brands/' + $(this).data('brand');

		$('.brands-filter button').removeClass('active');

		if (! $isActive) {
			$(this).addClass('active');
			$brand = $(this).data('brand');
		}

		$('#search-brand').val($brand);
		$('#search-category').val('');
		$('#search-form').attr('action', $url).trigger('submit');
	});

	if (params.has('brand')) {
		$('[data-brand="' + params.get('brand') + '"]').addClass('active');
	}

	// Logout
	$('.logout a').on('click', function (e) {
		e.preventDefault();

		$.post('/logout').then(resp => {
			window.location.replace('/');
		});
	});

	// Messages
	setTimeout(function () {
		$('.message.positive').animate({
			height: 'toggle',
			opacity: 'toggle'
		}, 500);
	}, 5000);

	// Sliders
	$('.home-slider').on('init', function (e, slick) {
		$('.home-slider').show();
	});

	$('.home-slider').slick({
		mobileFirst: true,
		dots: true,
		arrows: false,
		autoplay: true
	});

	$('.home-latest-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots: true,
		arrows: true,
		fade: false,
		autoplay: true,
		centerMode: true,
		responsive: [{
			breakpoint: 1800,
			settings: {
				slidesToShow: 5
			}
		}, {
			breakpoint: 1200,
			settings: {
				slidesToShow: 5
			}
		}, {
			breakpoint: 900,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 2
			}
		}]
	});

	$('.product-list-slider').slick({
		mobileFirst: true,
		dots: true,
		arrows: true,
		fade: false,
		autoplay: true,
		centerMode: true,
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}]
	});

	$('.product__slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		fade: true,
		cssEase: 'ease',
		autoplay: false
	});

	$('.product__slidernav').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.product__slider',
		focusOnSelect: true,
		arrows: false,
		dots: false,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 800,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 2
			}
		}]
	});

	$('#related-products').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		focusOnSelect: true,
		arrows: true,
		dots: false,
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 700,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 500,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 350,
			settings: {
				slidesToShow: 1
			}
		}]
	});

	$('.slider-commercial').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots: true,
		arrows: true,
		fade: false,
		autoplay: true,
		centerMode: true,
		responsive: [{
			breakpoint: 1800,
			settings: {
				slidesToShow: 5
			}
		}, {
			breakpoint: 1200,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 900,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 2
			}
		}]
	});

	// Home: Brand Products Slider / Logo Grid

	$('.brands-slider').slick({
		speed: 10,
		autoplay: false,
		autoplaySpeed: 4000,
		adaptiveHeight: true,
		mobileFirst: true,
		responsive: [{
			breakpoint: 700,
			settings: {
				arrows: false
			}
		}]
	});

	$('.brands-grid a img').on('mouseenter', function () {
		$('.brands-slider').slick('slickGoTo', $(this).data('index'));
	});

});

$('.add-item').on('click', function (e) {
	e.preventDefault();

	let quantity = $('#product-quantity').val(),
		product_id = $(this).data('product-id');

	$.post('/add_item', {
		product: product_id,
		quantity: quantity !== undefined ? quantity : 1
	}).then(resp => {
		if (resp.success == false) {
			return false;
		}

		$('#cart_count').html(resp.cart_count);
		$('.cart .notification').toggleClass('active', resp.cart_count > 0);
		$(this).html('Added to Cart!');

		setTimeout(function () {
			$('.add-item').html('Add to Cart');
		}, 1000);

		return new Promise((resolve, reject) => {
			resolve({
				success: true
			});
		});
	});
});

$('.quantity-selection .number li').on('click', function () {
	$('#product-quantity').val($(this).data('qty'));
});

// Overlay Toggle
$('#toggle-burger').on('click', function () {
	$(this).toggleClass('active');
	$('#overlay-nav').toggleClass('open');

	if ($('#overlay-nav').hasClass('open')) {
		$('html, body').css('overflow', 'hidden');
	} else {
		$('html, body').css('overflow', 'auto');
	}
});

// Add to Cart QTY
$('.product__qtyminus').on('click', function () {
	var input = $(this).parent().find('input'),
		count = parseInt(input.val()) - 1;

	count = count < 1 ? 1 : count;
	input.val(count);

	return false;
});

$('.product__qtyplus').on('click', function () {
	var input = $(this).parent().find('input');
	input.val(parseInt(input.val()) + 1);
	return false;
});

// Scroll to
$(document).on('click', '.scroll-to', function (e) {
	e.preventDefault();

	var tar = $(this).attr('href');

	$('html, body').animate({
		scrollTop: $(tar).position().top - $('header').outerHeight()
	}, 500);
});

// Mobile category pop up
$(function () {
	if ($('.accordion dt').hasClass('active')) {
		$('.accordion dt.active').next('dd').show();
	}

	$(document).on('click', '.accordion dt', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass("active").next('dd').slideUp(200);
		} else {
			$(this).addClass("active").next('dd').slideDown(200);
		}
	});

	$(document).on('click', '.toggle-filter-lists', function (e) {
		e.preventDefault();
		$('.overlay').toggleClass('open toggle-filter-lists');
		$('.filter-lists-modal').toggleClass('active');
	});

	$('.popup-trigger').on('click', function (e) {
		e.preventDefault();
		$('.popup').addClass('is-visible');
	});

	$('.popup').on('click', function (e) {
		if ($(e.target).is('.popup-close') || $(e.target).is('.popup')) {
			e.preventDefault();
			$(this).removeClass('is-visible');
		}
	});

	$(document).on('keyup', function (e) {
		if (e.key === 'Escape') {
			$('.popup').removeClass('is-visible');
		}
	});
});

// Product filter collapsible
$('.product-collapsible').on('click', function () {
	if ($(this).hasClass('active')) {
		$(this).removeClass('active').next().css('max-height', 0);
		$('.brand-collapsible').addClass('active').next().css('max-height', '100%');
	} else {
		$(this).addClass('active').next().css('max-height', '100%');
		$('.brand-collapsible').removeClass('active').next().css('max-height', 0);
	}
});

$('.brand-collapsible').on('click', function () {
	if ($(this).hasClass('active')) {
		$(this).removeClass('active').next().css('max-height', 0);
		$('.product-collapsible').addClass('active').next().css('max-height', '100%');
	} else {
		$(this).addClass('active').next().css('max-height', '100%');
		$('.product-collapsible').removeClass('active').next().css('max-height', 0);
	}
});

$('.collapsible').on('click', function () {
	let temp = $(this).hasClass('active'),
		content = $(this).next();

	$('.collapsible').removeClass('active').next().css('max-height', 0);

	if (! temp) {
		$(this).addClass('active');
	}

	if ($(this).hasClass('active')) {
		content.css('max-height', content.prop('scrollHeight') + 'px');
	} else {
		content.css('max-height', 0);
	}
});

function pinFooter() {
	let $contentHeight = 0;

	if ($('.page-header').length) {
		$contentHeight += $('.page-header').outerHeight(true);
	}

	if ($('footer').length) {
		$contentHeight += $('footer').outerHeight(true);
	}

	$('main').css('min-height', 'calc(100vh - ' + $contentHeight + 'px)');
}

// Scrollable cart total
$(function () {
	if ($('#sidebar').length) {
		var top = $('#sidebar').offset().top - parseFloat($('#sidebar').css('marginTop').replace(/auto/, 0)),
			footTop = $('#footer').offset().top - parseFloat($('#footer').css('marginTop').replace(/auto/, 0)),
			maxY = footTop - $('#sidebar').outerHeight();

		$(window).scroll(function (evt) {
			var y = $(this).scrollTop();

			if (y > top) {
				if (y < maxY) {
					$('#sidebar').addClass('fixed').removeAttr('style');
				} else {
					$('#sidebar').removeClass('fixed').css({
						position: 'absolute',
						top: maxY - top + 'px'
					});
				}
			} else {
				$('#sidebar').removeClass('fixed');
			}
		});
	}
});
